window.EmailRegistration=
{
	dlg:null,
	filer_permalink:null,
	filer_name:null,
	init:function() {
		/*var loader = new YAHOO.util.YUILoader({
	        //Get these modules
	        require: ['container','animation'],
	        allowRollup: true,
                loadOptional:true,
                //combine:true,
	        onSuccess: function() 
			{*/
                            if (jQuery('#email-alert-container').length>0)
                                return;

                jQuery('#cmd-register-email').click(function(){
                    jQuery('#frm_registration').submit();
                });

            jQuery('#frm_registration').submit(function(e){
                jQuery('#email-registration-alert').hide();
                e.preventDefault();
                if (jQuery('#user_email').val() == "") {
                    jQuery('#email-registration-alert').html('Please enter an email address');
                    jQuery('#email-registration-alert').show();
                    //whalewisdom.Utilities.show_alert("Incomplete Information","Please enter an email address");
                    return false;
                }
                whalewisdom.Utilities.toggle_wait(true);
                var form = jQuery( this );
                url = form.attr( 'action' );
                var params=form.serialize();

                var token = $('meta[name=csrf-token]').attr('content');
                jQuery.ajax({
                    url:url,
                    type:"POST",
                    headers: {
                      //  'Content-Type': 'application/json',
                        'X-CSRF-Token': token
                    },
                    dataType:'text',
                    data:{user_email:jQuery('#user_email').val(),permalink:jQuery('#permalink').val(),
                        registration_type:jQuery('#registration_type').val()},
                    success:function( data ) {
                        jQuery('#dlg_registration').modal('hide');
                        response = data.split("<!")[0];
                        //document.getElementById("reg_resp").innerHTML = response;
                        whalewisdom.Utilities.toggle_wait(false);
                        whalewisdom.Utilities.show_alert('Email Registration',response);
                    },
                    error:function(o) {
                        whalewisdom.Utilities.toggle_wait(false);
                        whalewisdom.Utilities.show_alert('There was a problem.',"Submission failed: " + o.status+"-"+ o.responseText);
                    }
                });
               /* jQuery.post( url, {user_email:jQuery('#user_email').val(),permalink:jQuery('#permalink').val(),
                    registration_type:jQuery('#registration_type').val()},
                      function( data ) {
                          jQuery('#dlg_registration').modal('hide');
                        response = data.split("<!")[0];
                        //document.getElementById("reg_resp").innerHTML = response;
                        whalewisdom.Utilities.toggle_wait(false);
                        whalewisdom.Utilities.show_alert('Email Registration',response);
                      },"text"
                    ).error(function(o) {
                        whalewisdom.Utilities.toggle_wait(false);
                        whalewisdom.Utilities.show_alert('There was a problem.',"Submission failed: " + o.status+"-"+ o.responseText);
                    });*/
               return false;
                    });
        jQuery('#lnk_email_registration').click(EmailRegistration.show);
                          //      YAHOO.util.Dom.removeClass("dlg_registration", "yui-pe-content");
				// Instantiate the Dialog
			/*	EmailRegistration.dlg = new YAHOO.widget.Dialog("dlg_registration",
										{ width : "30em",
										  fixedcenter : true,
                                                                                  effect:{effect:YAHOO.widget.ContainerEffect.FADE,duration:0.25},
										  visible : false, 
										  constraintoviewport : true,
										  hideaftersubmit:true,
										  buttons : [ { text:"Submit", handler:handleSubmit, isDefault:true },
											      { text:"Cancel", handler:handleCancel } ]
										});
                                YAHOO.util.Dom.removeClass("dlg_registration", "hidden");         */
				// Validate the entries in the form to require that both first and last name are entered


				/*		EmailRegistration.dlg.validate = function() {
					var data = this.getData();
                                        var valid=true;
					if (data.user_email == "") {
						whalewisdom.Utilities.show_alert("Incomplete Information","Please enter an email address");
						valid=false;
					} 
                                        if (!valid){
                                            
                                        }
                                        return valid;
				};
			 
				// Wire up the success and failure handlers
				EmailRegistration.dlg.callback = { success: handleSuccess,
									     failure: handleFailure };
				
				// Render the Dialog
				EmailRegistration.dlg.render();    */
			 	//$('dlg_registration_hider').style.display="block";

                                
			/*}});
			loader.insert();*/
		
	},
	show:function(){
        jQuery('#email-registration-alert').hide();
        jQuery('#user_email').val('');
        jQuery('#dlg_registration').modal({
        });
		//EmailRegistration.dlg.show();
	}
}
jQuery(function () {
    EmailRegistration.init();
});